import React, {useEffect, useState} from "react";
import Layout from "../../layout/Layout/Layout";
import {Box} from "@mui/material";
import {DataGrid, GridCellParams} from "@mui/x-data-grid";
import axios from "axios";
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import {toast} from "react-toastify";
import Loader from "../loader/loader";
import {APP_CONFIGURATION} from "../../app-config/configuration";


interface BlogDataType {
    id: string;
    title: string;
    desc: string;
    author: string;
    img: string;
    date: string;
    slugUrl: string;
}

const Hackathon = () => {
    const [blogData, setBlogData] = useState<BlogDataType[]>([]);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const onOpenModal = (id: any) => {
        setOpen(true);
        setDeleteId(id)
    }
    const onCloseModal = () => setOpen(false);

    const handleDelete = () => {
        const payload = {
            id: deleteId
        }
        setLoading(true)
        // @ts-ignore
        axios.delete(`${APP_CONFIGURATION.APP_CONSTANT.UAT_AUTH_URL}wtl/api/v1/hackathon/${payload.id}`)
            .then((res) => {
                if (res.status) {
                    setLoading(false)
                    toast.success("Deleted Successfully");
                    onCloseModal()
                    getAllHackathon()
                }
            })
            .catch((err) => {
                // Handle the error
            });
    }
    const onToggle = (id: any, status: boolean) => {
        const token = localStorage.getItem("auth_token");

        if (!token) {
            console.error("Authentication token is missing");
            return;
        }

        const url = `https://gatewayapi-uat.worldtradingleagues.com/wtl/api/v1/${id}/visibility?visible=${status}`;

        axios.post(url, {}, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then((res) => {
                console.log("Response status:", res.status);
                console.log("Response data:", res.data);
                // Update your component's state here instead of reloading the page
            })
            .catch((err) => {
                if (err.response) {
                    console.error("API call failed with status:", err.response.status);
                    console.error("Error data:", err.response.data);
                } else {
                    console.error("API call failed:", err.message);
                }

                // Handle specific error codes
                if (err.response?.status === 401) {
                    console.error("Unauthorized: The token might be invalid or expired.");
                    // Optionally, redirect to login or refresh token
                }
            });
    };


    const handleEdit = (id: string) => {
        window.location.replace(`/create-blog/${id}`);
    }
    const columns = [
        {
            field: "srNo", // Update the field name to match the property name in the data
            headerName: "Sr. No.",
            width: 60,
            renderCell: (params: GridCellParams) => <div style={{textAlign: 'center'}}>{(params.value as number)}</div>,
        },
        {
            field: "hackathonName",
            headerName: "Hackathon Name",
            width:250,
            renderCell: (params: GridCellParams) => <div style={{textAlign: 'center'}}>{(params.value as string)}</div>,
        },
        {
            field: "email",
            headerName: "Email",
            width: 250,
            renderCell: (params: GridCellParams) => <div style={{textAlign: 'center'}}>{(params.value as string)}</div>,
        },
        {
            field:"rulesAndRegulations",
            headerName: "Rules And Regulations",
            width: 304,
            renderCell: (params: GridCellParams) => (
                <div style={{textAlign: 'center'}}>
                    <img src={(params.value as string)} alt={(params.value as string)} style={{width: "100%"}}/>
                </div>
            ),
        },
        {
            field: "phone",
            headerName: "Phone",
            width: 250,
            renderCell: (params: GridCellParams) => (
                <div style={{textAlign: 'center'}}>
                    {(params.value as string)}
                </div>
            ),

        },
        {
            field: "fileFormat",
            headerName: "File Format",
            width: 230,
            renderCell: (params: GridCellParams) => (
                <div style={{textAlign: 'center'}}>
                    {(params.value as string)}
                </div>
            ),

        },
        {
            field: "actions",
            headerName: "Actions",
            width: 190,
            renderCell: (params: GridCellParams) => <div style={{textAlign: 'center'}}>
                <button
                    className={params.row.visible ? 'active' : 'inactive'}
                    onClick={() => onToggle(params.row.id, !params.row.visible)}
                >
                    {params.row.visible ? 'Active' : 'Inactive'}
                </button>
                <button style={{background: '#012970', border: 'none'}} className='btn btn-danger mr-4' type="button"
                        onClick={() => handleEdit(params.row.id)}>
                    Edit
                </button>
                <button className='btn btn-danger' type="button" onClick={() => onOpenModal(params.row.id)}
                        style={{marginLeft: '10px'}}>
                    Delete
                </button>
            </div>
        }
    ];

    useEffect(() => {
        getAllHackathon()
    }, []);
    const getAllHackathon = () => {
        setLoading(true)
        axios
            .get(`${APP_CONFIGURATION.APP_CONSTANT.UAT_AUTH_URL}wtl/api/v1/hackathons`)
            .then((res) => {
                const blogDataWithKeys = res.data.map((item: BlogDataType, index: number) => ({
                    ...item,
                    id: item.id.toString(),
                    srNo: index + 1, // Add a new property for Sr. No.
                }));
                setBlogData(blogDataWithKeys);
                setLoading(false)
            })
            .catch(() => {
            });
    }

    // @ts-ignore
    return (
        <>
            <Layout>
                <main id="main" className="main">
                    <div className="pagetitle mt-3">
                        <h1>Hackathon</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    Home
                                </li>
                                <li className="breadcrumb-item active">Hackathon</li>
                            </ol>
                        </nav>
                    </div>
                    <section className="section dashboard">
                        <Loader loading={loading}/>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 mt-5">
                                    <Box>
                                        <DataGrid
                                            rows={blogData}
                                            columns={columns}
                                            pagination
                                            // rowCount={blogData.length}
                                            // pageSizeOptions={[10, 15, 25]}
                                        />
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Modal open={open} onClose={onCloseModal} center>
                    <div className='p-5 text-center'>
                        <h3>Are You Sure You Want to Delete?</h3>
                        <div className="mt-3">
                            <button className="btn btn-danger ml-5" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-secondary mr-4" style={{marginLeft: '10px'}}
                                    onClick={onCloseModal}>Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
            </Layout>
        </>
    );
};

export default Hackathon;
